'use client';
import styled from 'styled-components';

export const ScBonanzaPromoSnackbarContent = styled.div`
  display: flex;
  gap: 4px;

  a {
    color: ${({ theme }) => theme.mainColor};
    text-decoration-line: underline;
    font-weight: bold;
    &:hover {
      cursor: pointer;
      color: ${({ theme }) => theme.mainColorHover};
    }
  }
`;
